import { render } from "./ChatBubble.vue?vue&type=template&id=89f56fb2&scoped=true&ts=true"
import script from "./ChatBubble.vue?vue&type=script&lang=ts"
export * from "./ChatBubble.vue?vue&type=script&lang=ts"

import "./ChatBubble.vue?vue&type=style&index=0&id=89f56fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f56fb2"]])

export default __exports__